import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";
const json = {
  1: {
    unit: "Unit 1",
    id: "SB7-U1-P16-E3",
    audio: "",
    video: "",
    component: UI,
    // recorder: true,
    titleQuestion: [
      {
        num: "",
        title: `<img src="img/FriendsPlus/Page9/Demo/a.jpg" style="height:30mm;margin-top:-40px "/>`,
        color: "#cf2370",
        prefix: { icons: [] },
      },
    ],
    newWords: [
      {
        title: "Tra cứu",
        description: `
        <span>Tra cứu</span>
        
        `,
      },
    ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>hướng dẫn</span>
        
        `,
      },
    ],
    questionImage: [
      [
        { url: "img/FriendsPlus/Page9/Demo/1.jpg" },
        {
          url: "img/FriendsPlus/Page9/Demo/2.jpg",
          audioUrl: "Audios/Đây là góc nhọn.mp3",
        },
        { url: "img/FriendsPlus/Page9/Demo/3.jpg" },
        {
          url: "img/FriendsPlus/Page9/Demo/4.jpg",
          audioUrl: "Audios/Đây là góc tù.mp3",
        },
        { url: "img/FriendsPlus/Page9/Demo/5.jpg" },
        {
          url: "img/FriendsPlus/Page9/Demo/6.jpg",
          audioUrl: "Audios/Đây là góc bẹt.mp3",
        },
        { url: "img/FriendsPlus/Page9/Demo/7.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page9/Demo/8.jpg" }],
    ],
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/Page9/Demo/Key1.png",
    component: T6,
    isHiddenCheck: true,
    // protractor: true,
    // hideBtnFooter: true,
    // isEssay:true,
    // maxLength:3,
    stylesTextInput: {
      fontSize: 23,
      borderBottom: "dash",
      textAlign: "center",
    },
    inputSize: 150,
    textareaStyle: { width: 800 },
    newWords: [
      {
        title: "Tra cứu",
        description: `
        <span>Tra cứu</span>
        
        `,
      },
    ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>hướng dẫn</span>
        
        `,
      },
    ],
    protractor: [
      {
        decreaseLeft: 180,
        decreaseTop: 200,

        rotateLeftThan0: 40,
        rotateTopThan0: 40,

        rotateLeftLess0: -10,
        rotateTopLess0: 33,

        inputLeft: "795px",
        inputBottom: "66px",
        result: [{}],
      },
    ],
    titleQuestion: [
      {
        num: "",
        title: ` <img src="img/FriendsPlus/Page9/Demo/a.jpg" style="height:30mm;margin-left:-20px;margin-top:-30px "/> `,
        color: "rgb(3, 103, 181)",
        // star: 1
      },
    ],
    // recorder: true,
    questionImage: [],
    questions: [
      {
        title: `
			<div style='display:flex'>
				<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
				  <b>1</b>
				</div>
			  Tìm các góc nhọn, góc tù và góc bẹt trong các góc sau.
			</div>
			
			<img src="/img/FriendsPlus/Page9/Demo/c.jpg"  style="height:8cm;margin-left:70px" >
			<div style='display:flex;justify-content:space-around;margin-top:20px'>
				<div>
					Góc nhọn:#
				</div>
				<div>
					Góc tù:#
				</div>
				<div>
					Góc bẹt:#
				</div>
			</div>

			<div
          id="protractor"
          style="position: absolute;top: 454px;left: 0px;width: 400px; height: 420px;z-index: 0"
        >
          <img
            src="/img/test/protractor-removebg-preview2.png"
            style="width: 400px"
            alt="image"
          />
        </div>
				
			`,
        answer: [
          "MON, VDU / NOM, VDU / VDU, NOM / VDU, MON / O, D / D, O",
          "A / GAH / HAG",
          "XEY / YEX / E",
        ],
      },
    ],
  },
  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/Page9/Demo/Key2.png",
    component: T6,
    isHiddenCheck: true,
    protractor: true,
    hideBtnFooter: true,
    maxLength: 3,
    stylesTextInput: { fontSize: 23, borderBottom: "none", textAlign: "end" },
    inputSize: 60,
    textareaStyle: { width: 800 },
    newWords: [
      {
        title: "Tra cứu",
        description: `
        <span>Tra cứu</span>
        
        `,
      },
    ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>hướng dẫn</span>
        
        `,
      },
    ],
    titleQuestion: [
      {
        num: "",
        title: ` <img src="img/FriendsPlus/Page9/Demo/1.jpg" style="height:30mm;margin-left:-20px;margin-top:-30px "/> `,
        color: "rgb(3, 103, 181)",
        // star: 1
      },
    ],
    recorder: true,

    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
			<div style='display:flex'>
				<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
				  <b>3</b>
				</div>
			  Dùng thước đo góc để đo các góc được tạo bởi hai kim đồng hồ khi đồng hồ chỉ 3 giờ, 4giờ, 6giờ, 2 giờ.
			</div>
			
			<div style='display:flex; '>
			  <div >
				<img src="/img/FriendsPlus/Page9/Demo/4.jpg"  style="height:5cm;margin-left:70px" >
				  <div style='margin-left:150px' >
					<b>A</b>
				  </div>
			  </div>
			  <div >
				<img src="/img/FriendsPlus/Page9/Demo/5.jpg"  style="height:5cm;margin-left:70px" >
				  <div style='margin-left:150px' >
					<b>B</b>
				  </div>
			  </div>
			  <div >
				<img src="/img/FriendsPlus/Page9/Demo/6.jpg"  style="height:5cm;margin-left:70px" >
				  <div style='margin-left:150px' >
					<b>C</b>
				  </div>
			  </div>
			  <div >
				<img src="/img/FriendsPlus/Page9/Demo/7.jpg"  style="height:5cm;margin-left:70px" >
				  <div style='margin-left:150px' >
					<b>D</b>
				  </div>
			  </div>
	
			</div>
				
			`,
        answer: ["60", "120", "90", "60"],
      },
    ],
  },

  // 3: {
  // 	unit: 'Unit Starter',
  // 	id: 'FP8-WB-demo-2023-US-P9-E3',
  // 	component: T6v2,
  // 	// hideBtnFooter: true,
  // 	inputSize: 110,
  // 	exerciseKey:"/img/FriendsPlus/Page9/Key/E3answerKey.png",
  // 	stylesTextInput: {
  // 		fontSize: '24px',
  // 		textAlign:'center',
  // 		background:'none' ,
  // 		fontWeight:'bold'

  // 	},
  // 	titleQuestion: [
  // 		{
  // 			title: `
  // 			<div style='display:flex'>
  // 			<div style="background-color: rgb(61, 184, 187); border-radius: 50%; color: white; width: 39px; height: 39px; text-align: center; line-height: 39px;margin-right:10px">
  // 			3
  // 		</div>
  // 			Tính giá trị của biều thức.
  // 			</div>

  // 			`,
  // 			color: 'rgb(28, 192, 217)',
  // 		},
  // 	],
  // 	isHiddenCheck: true,
  // 	questions: [
  // 		{
  // 			title: `
  // 			<div style='display:flex'>
  // 		<div style='background-color:rgb(240,209,227);border-radius:15px;padding:10px 10px;'>
  // 		57 670 - (29 653 - 2653) = #

  // 		</div>

  // 		<div style='background-color:rgb(240,209,227);border-radius:15px;padding:10px 10px;margin-left:150px;'>
  // 		16 000 + 8 140 + 2 760 = #
  // 		</div>

  // 		</div>
  //     `,
  // 			answer: [`30 670 | 30670`,`26 900 | 26900`],
  // 		},
  // 	],
  // },
  // 1: {
  // 	unit: 'Unit Starter',
  // 	id: 'FP8-WB-demo-2023-US-P9-E3',
  // 	exerciseKey:"/img/FriendsPlus/Page9/Key/E1answerKey.png",
  // 	component: T6,
  // 	inputSize: 105,
  // 	maxLength:7,

  // 	textareaStyle: { width: 600 },
  // 	stylesTextInput: {
  // 		fontSize: '25px',
  // 		textAlign:'center',
  // 	},
  // 	titleQuestion: [
  // 		{
  // 			title: `
  // 			<div style='display:flex'>
  //     <div style="background-color: rgb(61, 184, 187); border-radius: 50%; color: white; width: 39px; height: 39px; text-align: center; line-height: 39px;margin-right:10px">
  //     1
  // </div>        Tính nhẩm.
  //     </div>			`,
  // 			color: 'rgb(28, 192, 217)',
  // 		},
  // 	],
  // 	isHiddenCheck: true,
  // 	questions: [
  // 		{
  // 			title: `
  // 		<div style='display:flex'>
  // 		<div style='margin-left:100px'>
  // 		a)
  // 		</div>
  // 		<div style='margin-left:450px'>

  // 		b)
  // 		</div>
  // 		</div>
  // 		<div style='display:flex;position:relative'>
  // 		<div>
  // 		<img src='/img/FriendsPlus/Page9/images/1.jpg' width='100%'/>
  // 		</div>

  // 		<div style='margin-top:7px'>

  // 		<img src='/img/FriendsPlus/Page9/images/2.jpg' width='100%'/>

  // 		</div>
  // 		<div style='position:absolute;top:85px;left:155px;line-height:2'>
  // 		8 000 + 7 000 = # <br>
  // 		16 000 - 9 000 = # <br>
  // 		25 000 + 30 000 = #
  // 		</div>
  // 		<div style='position:absolute;top:85px;left:575px;line-height:2'>
  // 		46 000 + 4 000 + 9 000 = # <br>
  // 		73 000 - 3 000 - 50 000 = # <br>
  // 		32 000 + 5 000 - 17 000 = #
  // 		</div>
  // 		</div>

  //     `,
  // 			answer: [
  // 				`15 000 | 15000`,`7 000 | 7000`,`55 000 | 55000`,`59 000 | 59000`,`20 000 | 20000`,`20 000 | 20000`,

  // 			],
  // 		},
  // 	],
  // },
  // 2: {
  // 	unit: 'Unit Starter',
  // 	id: 'FP8-WB-demo-2023-US-P9-E3',
  // 	exerciseKey:"/img/FriendsPlus/Page9/Key/E2answerKey.png",
  // 	component: T6,
  // 	inputSize: 105,
  // 	maxLength:7,

  // 	textareaStyle: { width: 600 },
  // 	stylesTextInput: {
  // 		fontSize: '25px',
  // 		textAlign:'center',
  // 		background:'none',
  // 		fontWeight:'bold'

  // 	},
  // 	titleQuestion: [
  // 		{
  // 			title: `
  // 			<div style='display:flex'>
  // 			<div style="background-color: rgb(61, 184, 187); border-radius: 50%; color: white; width: 39px; height: 39px; text-align: center; line-height: 39px;margin-right:10px">
  // 			2
  // 		</div>
  // 			Đặt tính rồi tính.
  // 			</div> 			`,
  // 		},
  // 	],
  // 	isHiddenCheck: true,
  // 	questions: [
  // 		{
  // 			title: `
  // 		<div style='display:flex'>
  // 		<div>
  // 		<div style='background-color:rgb(243,209,181);border-radius:15px;padding:10px 10px;'>
  // 		8 254 + 6 392 = #
  // 		</div>
  // 		<div style='background-color:rgb(243,209,181);border-radius:15px;padding:10px 10px;margin-top:30px'>
  // 		36 073 - 847 = #
  // 		</div>
  // 		</div>
  // 		<div style='margin-left:150px;'>
  // 		<div style='background-color:rgb(243,209,181);border-radius:15px;padding:10px 10px;'>
  // 		58 623 + 25 047 = #
  // 		</div>
  // 		<div style='background-color:rgb(243,209,181);border-radius:15px;padding:10px 10px;;margin-top:30px'>
  // 		74 528 + 16 240 = #
  // 		</div>

  // 		</div>
  // 		</div>

  //     `,
  // 			answer: [
  // 			`14 646 | 14646`,`35 226 | 35226 `,`83 670 | 83670`,`90 768 | 90768`,
  // 			],
  // 		},
  // 	],
  // },
  // 4: {
  // 	unit: 'Unit Starter',
  // 	id: 'FP8-WB-demo-2023-US-P9-E3',
  // 	exerciseKey:"",
  // 	component: T6,
  // 	inputSize: 105,
  // 	isEssay:true,

  // 	textareaStyle: { width: 800 },
  // 	stylesTextInput: {
  // 		fontSize: '25px',
  // 		textAlign:'center',
  // 		background:'none'
  // 	},
  // 	titleQuestion: [
  // 		{
  // 			title: `
  // 			<span style="background-color: rgb(28, 192, 217);   border-radius: 50%; color: white; text-align: center; padding:3px 7px;margin-right:10px">
  // 			4
  // 		</span>
  // 		Giá một hộp bút là 16 500 đồng, giá một ba lô học sinh nhiều hơn giá hộp bút là 62 5000 đồng. Mẹ mua cho
  // 		An một hộp bút và một ba lô học sinh. Hỏi mẹ của An phải trả người bán hàng bao nhiêu tiền?

  // 					`,
  // 		},
  // 	],
  // 	isHiddenCheck: true,
  // 	questions: [
  // 		{
  // 			title: `

  // 			<div  style='margin-top:30px' >
  // 			<div style='margin-left:500px'><u><i><b>Bài Giải:</b></i></u></div>
  // 			  <div  style='margin-left:150px'> <textarea id='0' rows='3'></textarea></div>

  // 			</div>

  //     `,
  // 			answer: [

  // 			],
  // 		},
  // 	],
  // },
};

export default json;
